export enum OfferStatus {
    Pending = 0,
    Rejected = 1,
    Accepted = 2,
    Withdrawn = 3,
    TenancyEnded = 4,
    AwaitingProof = 5
}